import { Dropdown, DropDownProps } from 'antd';
import React, { FC } from 'react';

export const ILSDropdown: FC<DropDownProps> = (props) => {
  return <Dropdown {...props} />;
};
